import { render, staticRenderFns } from "./AccessoryDetails.vue?vue&type=template&id=1bdf10ac&scoped=true&"
import script from "./AccessoryDetails.vue?vue&type=script&lang=js&"
export * from "./AccessoryDetails.vue?vue&type=script&lang=js&"
import style0 from "./AccessoryDetails.vue?vue&type=style&index=0&id=1bdf10ac&scoped=true&lang=scss&"
import style1 from "./AccessoryDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdf10ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bdf10ac')) {
      api.createRecord('1bdf10ac', component.options)
    } else {
      api.reload('1bdf10ac', component.options)
    }
    module.hot.accept("./AccessoryDetails.vue?vue&type=template&id=1bdf10ac&scoped=true&", function () {
      api.rerender('1bdf10ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/accessories/AccessoryDetails.vue"
export default component.exports